import styled, { keyframes } from "styled-components";

const flow = keyframes`
  0% { stroke-dashoffset: 0; }
  100% { stroke-dashoffset: -1000; } /* usa pathLength=1000 */
`;
const drift = keyframes`
  0% { transform: translateY(-8%); }
  100% { transform: translateY(20%); }
`;

export const BackgroundWrapper = styled.div`
  position: fixed;
  inset: 0;
  pointer-events: none;
  overflow: hidden;

  /* controla play/pausa globalmente */
  --play: running;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }

  /* Menos custo na GPU */
  .wave-line {
    vector-effect: non-scaling-stroke;
    stroke-dasharray: 1000; /* bate com pathLength */
    stroke-dashoffset: 0;
    animation: ${flow} var(--wave-duration, 10s) linear infinite;
    animation-delay: var(--wave-delay, 0s);
    animation-play-state: var(--play, running);
  }

  .ribbon-group {
    animation-name: ${drift};
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: var(--play, running);
  }

  /* Reduz ainda mais se usuário preferir menos animação */
  @media (prefers-reduced-motion: reduce) {
    .wave-line,
    .ribbon-group {
      animation-duration: 60s !important;
    }
  }

  /* Modo econômico explícito (setado no componente) */
  &[data-lowpower="1"] {
    .wave-line,
    .ribbon-group {
      animation-duration: calc(var(--wave-duration, 10s) * 1.4);
    }
  }
`;
